// import PropTypes from 'prop-types'
import React, { Component } from 'react';
import avatar from '../imagens/avatar.png'
import 'react-awesome-button/dist/styles.css';
import { AwesomeButton } from 'react-awesome-button';
import { FaGithub} from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";


import '../styles/Display.css';

export default class Display extends Component {

  render() {
    return (
      <section id="inicio">
        <div className="container-title-display">
          <h2>Alessandra Romualdo</h2>
          <h3 className="dev">Desenvolvedora Web</h3>
          <p>A persistência é o caminho do êxito.</p>
          <div className="container-link-display animate__animated animate__bounce">
          <AwesomeButton size="medium" type="github"><a href="https://github.com/AlessandraRomualdo" target="_blank" rel="noreferrer"><FaGithub /></a></AwesomeButton>

          <AwesomeButton size="medium" type="github"><a href="https://www.linkedin.com/in/alessandra-romualdo/" target="_blank" rel="noreferrer"><FaLinkedin/></a></AwesomeButton>
        </div>
        </div>
        <div className="container-img-avatar animate__animated animate__shakeX animate__slow	2s">
          <img src={avatar} alt="avatar de Alessandra" />
        </div>
      </section>
    )
  };
};
